module.exports = __webpack_public_path__ + "img/darkside_icon.45d27de8.png";